/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import {DEFAULT_SITE_TITLE} from '../../constants'
import {useIntl} from 'react-intl'

const Seo = ({title, description, keywords, noIndex, children, ...props}) => {
    const {formatMessage} = useIntl()
    const pageTitle = title ? title : formatMessage(DEFAULT_SITE_TITLE)
    return (
        <Helmet {...props}>
            <title>
                {formatMessage(
                    {
                        defaultMessage: '{pageTitle} | Stokke® Online Shop',
                        id: 'global.page.title'
                    },
                    {pageTitle: pageTitle}
                )}
            </title>
            {description && <meta name="description" content={description} />}
            {keywords && <meta name="keywords" content={keywords} />}
            {noIndex && <meta name="robots" content="noindex" />}
            {children}
        </Helmet>
    )
}

Seo.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    keywords: PropTypes.string,
    noIndex: PropTypes.bool,
    children: PropTypes.node
}

export default Seo
